import { type ComponentPropsWithoutRef } from "react";
import { Component, ExpandIcon } from "./styles";

export function ExpandButton(props: ComponentPropsWithoutRef<"button">) {
  return (
    <Component {...props}>
      <ExpandIcon disabled={props.disabled} />
    </Component>
  );
}
